module.exports = __webpack_public_path__ + "static/media/footer-logo.a501eb4d.svg";